/**
 * 存储tokens
 * @param {string} accessToken
 */
export function saveTokens (accessToken) {
  localStorage.setItem('access_token', `Bearer ${accessToken}`)
}

/**
 * 存储access_token
 * @param {string} accessToken
 */
export function saveAccessToken (accessToken) {
  localStorage.setItem('access_token', `Bearer ${accessToken}`)
}

/**
 * 获得某个token
 * @param {string} tokenKey
 */
export function getToken () {
  return localStorage.getItem('access_token')
}

/**
 * 移除token
 */
export function removeToken () {
  localStorage.removeItem('access_token')
}



// WEBPACK FOOTER //
// ./src/util/token.js